"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmDialog = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_1 = require("@veeam/components");
const Warning_svg_1 = __importDefault(require("@veeam/uikit-assets/src/icons/status/Warning/Warning.svg"));
const FeatureContext_1 = require("../../core/contexts/FeatureContext");
require("./types");
const TextWrapper = styled_components_1.default.div `
  word-break: ${(props) => props.wordBreak};
`;
const ConfirmDialog = ({ deactivate, loading, width = components_1.DIALOG_SIZE.xs, header, iconSrc = Warning_svg_1.default, message, messageWhiteSpace = components_1.TEXT_WHITE_SPACE.normal, doneActionLabel, cancelActionLabel, wordBreak = 'normal', onDone, onClose, }) => {
    const { t } = FeatureContext_1.useFeatureContext();
    return (react_1.default.createElement(components_1.Dialog, { id: "confirm", header: header || t('confirmDialog|header'), loading: loading, size: {
            width,
            height: components_1.DIALOG_SIZE.auto,
        }, onRequestClose: () => {
            if (!loading) {
                deactivate();
                onClose === null || onClose === void 0 ? void 0 : onClose();
            }
        }, actions: [
            {
                id: 'confirm-done',
                view: components_1.ACTION_VIEW.primary,
                text: doneActionLabel || t('confirmDialog|actions|done'),
                onClick: () => {
                    onDone === null || onDone === void 0 ? void 0 : onDone();
                },
            },
            {
                id: 'confirm-cancel',
                view: components_1.ACTION_VIEW.secondary,
                text: cancelActionLabel || t('confirmDialog|actions|cancel'),
                onClick: () => {
                    deactivate();
                    onClose === null || onClose === void 0 ? void 0 : onClose();
                },
            },
        ] },
        react_1.default.createElement(components_1.StackView, { gap: components_1.STACK_GAP.m, align: components_1.STACK_ALIGN.start },
            react_1.default.createElement(components_1.Icon, { src: iconSrc, size: components_1.ICON_SIZES.xl }),
            react_1.default.createElement(components_1.View, { align: components_1.VIEW_ALIGN.center, spaceFill: components_1.SPACE_FILL.all },
                react_1.default.createElement(TextWrapper, { wordBreak: wordBreak },
                    react_1.default.createElement(components_1.Text, { whitespace: messageWhiteSpace }, message || t('confirmDialog|message')))))));
};
exports.ConfirmDialog = ConfirmDialog;
exports.ConfirmDialog.displayName = 'ConfirmDialog';
//# sourceMappingURL=ConfirmDialog.js.map